<template>
  <div>
    <b-card class="standardpage reports">
      <b-card-header>
        <b-row align-h="between" align-v="center">
          <b-col class="text-sm-left pt-1">
            <i :class="bltransactions.icon" class="mr-1"></i>
            {{ bltransactions.title }}
          </b-col>
          <!-- <b-col cols="auto" class="text-right mb-n2" v-if="user.permissions.includes('boughtledger.admin')">
            <b-row no-gutters>
              <b-col cols="auto" class="mt-1">Archive ?</b-col>
              <b-col cols="auto"> <b-form-group label="" label-for="data" label-cols="12">
                  <b-form-radio-group id="isarchive" v-model="isarchive" :options="[
                    { text: 'No', value: '0' },
                    { text: 'Yes', value: '1' },
                  ]" buttons button-variant="outline-success" size="sm" name="radio-btn-outline">
                  </b-form-radio-group>
                </b-form-group></b-col>
            </b-row>

          </b-col> -->
        </b-row>
      </b-card-header>

      <div v-show="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">

            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <!-- <b-col cols="auto"> -->
                <b-form-group label-cols="12" label="Transaction Date" label-size="sm">
                  <!-- :timePicker="true"
                        :timePicker24Hour="true" -->
                  <b-input-group>
                    <daterangepicker size="sm" ref="datetransaction" v-model="datetransaction" :opens="'right'"
                      :locale-data="locale_data" :ranges="locale_ranges" :showDropdowns="true" :linkedCalendars="false"
                      :single-date-picker="false">
                    </daterangepicker>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="
                        datetransaction = {
                          startDate: null,
                          endDate: null,
                        }
                        ">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Supplier BL A/C" label-size="sm">
                  <treeselect placeholder="Select blac..." searchPromptText="Type at least 3 chars..." v-model="blac"
                    :multiple="true" :clearable="true" :async="true" :load-options="treeselect_loadBLAC"
                    :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                    search-nested>
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Event" label-size="sm">
                  <treeselect placeholder="Select event..." v-model="eventcode" :clearable="true" :async="true"
                    :multiple="true" :load-options="treeselect_loadEvent" :show-count="true"
                    :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm" class="mb-0">
                  <b-input-group class="treeselect_all justify-content-end pr-2px">
                    <span style="padding-top: 0.3em" class="text-primary" id="slaclike-tooltip">Like</span>
                    <b-form-checkbox id="slaclike" v-model="slaclike_visible" class="z-0">
                    </b-form-checkbox>
                  </b-input-group>
                  <b-input-group v-if="!slaclike_visible">
                    <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..." v-model="slac"
                      :multiple="true" :clearable="true" :async="true" :load-options="treeselect_loadSLAC"
                      :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                      search-nested>
                      <div slot="value-label" slot-scope="{ node }">
                        {{ node.raw.id }}
                      </div>
                    </treeselect>
                  </b-input-group>
                </b-form-group>
                <!-- <b-form-group
                  label-cols="12"
                  label="SL A/C (LIKE %)"
                  label-size="sm"
                > -->
                <b-input-group v-if="slaclike_visible">
                  <b-form-input v-model="slaclike" :debounce="bltransactions.debounce"
                    placeholder="Client SL A/C (LIKE %)" trim></b-form-input>
                  <b-input-group-append>
                    <b-button size="sm" variant="outline-secondary" :disabled="!slaclike" @click="slaclike = ''">
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
                <!-- </b-form-group> -->
              </b-col>


              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Ref" label-size="sm" class="mb-0">
                  <b-input-group class="treeselect_all justify-content-end pr-2px">
                    <span style="padding-top: 0.3em" class="text-primary" id="reflike-tooltip">Like</span>
                    <b-form-checkbox id="reflike" v-model="reflike_visible" class="z-0">
                    </b-form-checkbox>
                  </b-input-group>
                  <b-input-group v-if="!reflike_visible">
                    <b-form-tags input-id="reflist" v-model="reflist" tag-variant="primary" separator=" ,;"
                      placeholder="Paste Ref List (IA519826,IA519827,...)" size="sm" class="h-29" add-button-text="+"
                      add-on-change remove-on-delete add-button-variant="outline-primary"></b-form-tags>
                    <!-- placeholder="Enter transaction refs separated by space, comma or semicolon" -->
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="reflist = null">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>

                <b-input-group v-if="reflike_visible">
                  <b-form-input v-model="ref" :debounce="bltransactions.debounce" placeholder="Ref Like (IA,IC,CM)"
                    trim></b-form-input>
                  <b-input-group-append>
                    <b-button size="sm" variant="outline-secondary" :disabled="!ref" @click="ref = ''">
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>

              </b-col>

              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Transaction Ref ( Paste List )" label-for="reflist" label-cols="12">
                  <b-input-group class="z-0">
                    <b-form-tags input-id="reflist" v-model="reflist" tag-variant="primary" separator=" ,;"
                      placeholder="Paste Ref (IA519826,IA519827,...)" size="sm" class="h-29" add-button-text="+"
                      add-on-change remove-on-delete add-button-variant="outline-primary"></b-form-tags>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="reflist = null">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Transaction Ref (LIKE %)" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="ref" :debounce="bltransactions.debounce" placeholder="Ref (IA,IC,CM)"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!ref" @click="ref = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col> -->


              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Youf Ref / PO" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="yourref" :debounce="bltransactions.debounce"
                      placeholder="Youf Ref"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!yourref" @click="yourref = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>



              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Description" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="passenger" :debounce="bltransactions.debounce" placeholder="Description"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!passenger" @click="passenger = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Transaction Type" label-size="sm">
                  <treeselect placeholder="Select type..." v-model="type" :multiple="true" :clearable="true"
                    :options="type_options" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                  </treeselect>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Ticket No ( Paste List )" label-for="reflist1" label-cols="12">
                  <b-input-group class="z-0">
                    <b-form-tags input-id="reflist1" v-model="ticketno" tag-variant="primary" separator=" ,;"
                      placeholder="Paste Ref (333..,333...)" size="sm" class="h-29" add-button-text="+" add-on-change
                      remove-on-delete add-button-variant="outline-primary"></b-form-tags>
                    <!-- placeholder="Enter transaction refs separated by space, comma or semicolon" -->
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="ticketno = []">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>



              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="BSP Ref" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="bspref" :debounce="bltransactions.debounce" placeholder="BSP Ref"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!bspref" @click="bspref = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Conferma TransactionId ( Paste List )" label-for="confermatransactionid"
                  label-cols="12">
                  <b-input-group class="z-0">
                    <b-form-tags input-id="confermatransactionid" v-model="confermatransactionid" tag-variant="primary"
                      separator=" ,;" placeholder="Paste Conferma TransactionId (1234109,1234110,...)" size="sm"
                      class="h-29" add-button-text="+" add-on-change remove-on-delete
                      add-button-variant="outline-primary"></b-form-tags>
                    <!-- placeholder="Enter transaction refs separated by space, comma or semicolon" -->
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="confermatransactionid = []">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Cr Ref" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="refcredit" :debounce="bltransactions.debounce"
                      placeholder="Cr Ref"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!refcredit" @click="refcredit = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label-cols="12"
                    label="Invoice type"
                    label-size="sm"
                  >
                    <treeselect
                      v-model="transtype"
                      :clearable="true"
                      :options="transtype_options"
                    ></treeselect>
                  </b-form-group>
                </b-col> -->
              <!--   <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label="Value type"
                    label-for="credit"
                    label-cols="12"
                  >
                    <b-input-group class="z-0">
                      <b-form-radio-group
                        id="credit"
                        v-model="credit"
                        :options="[
                          { text: 'Invoice', value: false },
                          { text: 'Credit Note', value: true },
                        ]"
                        buttons
                        button-variant="outline-success"
                        size="sm"
                        name="radio-btn-outline"
                      ></b-form-radio-group>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          @click="credit = null"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col> -->
              <!--   <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label="Value is"
                    label-for="amount"
                    label-cols="12"
                  >
                    <b-input-group class="z-0">
                      <b-form-radio-group
                        id="payment"
                        v-model="ispaid"
                        :options="[
                          { text: 'Paid', value: true },
                          { text: 'Unpaid', value: false },
                        ]"
                        buttons
                        button-variant="outline-success"
                        size="sm"
                        name="radio-btn-outline"
                      ></b-form-radio-group>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          @click="ispaid = null"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col> -->
            </b-row>
            <b-row class="mx-0 bg-lavenderblush" v-if="user.permissions.includes('boughtledger.admin') && !showfilter">
              <b-col cols="12" sm="6" md="4" xl="3" class="pl-0">
                <b-form-group label-cols="12" label="Ledger query" label-size="sm">
                  <treeselect id="bl-query" placeholder="Select ledger query..." :clearable="false" v-model="query"
                    :options="blquery_options" :disable-branch-nodes="true" :show-count="true"
                    :default-expand-level="1" />
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3" class="pl-2">
                <b-form-group label="Active?" label-for="active" label-cols="12">
                  <treeselect instanceId="active" type="number" v-model="isactive" :clearable="true"
                    :options="active_options"></treeselect>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3" v-if="permissionvalid('systems.development')">
                <b-row>
                  <b-col>
                    <b-form-group label-cols="12" label="Comm. (min)" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="comm.min" :debounce="bltransactions.debounce" placeholder="(min)" trim
                          :disabled="iscommnotzero"> </b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="!comm.min"
                            @click="comm.min = null">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label-cols="12" label="(max)" label-size="sm">
                      <b-input-group class="treeselect_all justify-content-end pr-2px">
                        <span style="padding-top: 0.3em" class="text-primary">Not Zero</span>
                        <b-form-checkbox id="iscommnotzero" v-model="iscommnotzero" class="z-0">
                        </b-form-checkbox>
                      </b-input-group>
                      <b-input-group>
                        <b-form-input v-model="comm.max" :debounce="bltransactions.debounce" placeholder="(max)" trim
                          :disabled="iscommnotzero"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="!comm.max"
                            @click="comm.max = null">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>


                </b-row>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3"
                v-if="permissionvalid('systems.development') || user.department == 'ACCOUNTS'">
                <b-row>
                  <b-col>
                    <b-form-group label-cols="12" label="Amount (min)" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="amnt.min" :debounce="bltransactions.debounce" placeholder="(min)" trim>
                        </b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="!amnt.min"
                            @click="amnt.min = null">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label-cols="12" label="(max)" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="amnt.max" :debounce="bltransactions.debounce" placeholder="(max)"
                          trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="!amnt.max"
                            @click="amnt.max = null">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>


                </b-row>
              </b-col>


            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <d-table classdivtable="availtable datatable" refid="bltransactions" :selectall="bltransactions.selectall"
            :icon="bltransactions.icon" :busy="bltransactions.busy" :toolbarlibrary="bltransactions.toolbarlibrary"
            :tools="bltransactions.tools" :toolbar="bltransactions.toolbar" :badges="bltransactions.badges"
            :fields="bltransactions.fields" :items="bltransactions.items" :offset="bltransactions.offset"
            :downloaded="bltransactions.downloaded" :limit="bltransactions.limit" :page="bltransactions.page"
            :showpages="true" @load="bltransactions_load" @click="bltransactions_click" @select="bltransactions_select">
          </d-table>
        </div>
      </div>

      <div v-show="component">
        <component :is="component" :value="item" :selection="bltransactions.selected" :config="cconfig"
          @discard="bltransactions_click('discard')"></component>
      </div>

      <b-row class="px-3">
        <b-col>
          <b-alert :show="!component && !bltransactions.busy && bltransactions.items.length == 0" variant="success">
            <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
              <b-col>
                Click
                <b-link id="report-go" class="mt-1 mx-2 nodecoration" title="Go" @click="bltransactions_click('go')"">
                  <i class=" fa fa-play pr-1" aria-hidden="true"></i>Go
                </b-link>when all filter changes are complete.</b-col></b-row>
          </b-alert></b-col>
      </b-row>

    </b-card>
  </div>
</template>


<script>
import gql from "graphql-tag";

// import SLInvoiceEdit from "./Components/SLInvoiceEdit";
import BLItemEdit2 from "./Components/BLItemEdit2";
import BLInvoiceEdit from "./Components/BLInvoiceEdit";
import BLAdjustments from "./Components/BLAdjustments";
import BLItemCredit from "./Components/BLItemCredit";
import BLAmend from "./Components/BLAmend";
import FilesUpload from "../../Components/FilesUpload";
import TicketsInvoice from "../Tickets/Components/TicketsInvoice";
import BLMatch from "./Components/BLMatch";
import BLPayment from "./Components/BLPayment";

export default {
  name: "BLTransactions",
  components: {
    // SLInvoiceEdit,
    BLItemEdit2,
    BLInvoiceEdit,
    BLAdjustments,
    BLAmend,
    FilesUpload,
    TicketsInvoice,
    BLItemCredit,
    BLMatch,
    BLPayment
  },
  watch: {
    async ref() {
      console.log("ref", this.ref);
      if (this.ref) {
        this.datetransaction = { startDate: null, endDate: null }
        this.credit = null;
      } else {
        this.datetransaction = { startDate: this.$moment().format("YYYY-MM-DD"), endDate: this.$moment().format("YYYY-MM-DD") }
      }
      await this.bltransactions_clear();
    },
    async reflist() {
      console.log("reflist", this.reflist);
      if (this.reflist.length > 0) {
        this.datetransaction = { startDate: null, endDate: null }
        this.credit = null;
      } else {
        this.datetransaction = { startDate: this.$moment().format("YYYY-MM-DD"), endDate: this.$moment().format("YYYY-MM-DD") }
      }
      await this.bltransactions_clear();
    },
    async reflike_visible() {
      if (this.reflike_visible) {
        this.reflist = []
      } else {
        this.ref = null
      }
      await this.bltransactions_clear();
    },
    async reflike() {
      await this.bltransactions_clear();
    },
    async datetransaction() {
      await this.bltransactions_clear();
    },
    async credit() {
      await this.bltransactions_clear();
    },
    async slac() {
      await this.bltransactions_clear();
    },
    async slaclike_visible() {
      if (this.slaclike_visible) {
        this.slac = []
      } else {
        this.slaclike = null
      }
      await this.bltransactions_clear();
    },
    async slaclike() {
      await this.bltransactions_clear();
    },
    async blac() {
      if (this.blac) {
        this.datetransaction = { startDate: null, endDate: null }
      }
      await this.bltransactions_clear();
    },
    async passenger() {
      await this.bltransactions_clear();
    },
    async bspref() {
      await this.bltransactions_clear();
    },
    async yourref() {
      await this.bltransactions_clear();
    },
    async refcredit() {
      await this.bltransactions_clear();
    },
    async eventcode() {
      await this.bltransactions_clear();
    },
    // async confermatransactionid() {
    //   await this.bltransactions_clear();
    // },
    async confermatransactionid() {
      if (this.confermatransactionid.length > 0) {
        this.datetransaction = { startDate: null, endDate: null }
        this.credit = null;
      } else {
        this.datetransaction = { startDate: this.$moment().format("YYYY-MM-DD"), endDate: this.$moment().format("YYYY-MM-DD") }
      }
      await this.bltransactions_clear();
    },
    async ticketno() {
      if (this.ticketno.length > 0) {
        this.datetransaction = { startDate: null, endDate: null }
        this.credit = null;
      } else {
        this.datetransaction = { startDate: this.$moment().format("YYYY-MM-DD"), endDate: this.$moment().format("YYYY-MM-DD") }
      }
      await this.bltransactions_clear();
    },
    async query() {
      await this.bltransactions_clear();
    },
    async type() {
      await this.bltransactions_clear();
    },
    async ispaid() {
      await this.bltransactions_clear();
    },
    async amnt() {
      await this.bltransactions_clear();
    },
    async comm() {
      await this.bltransactions_clear();
    },
    async iscommnotzero() {
      await this.bltransactions_clear();
    },
    async isarchive() {
      await this.bltransactions_clear();
    },
    async active() {
      await this.bltransactions_clear();
    },
    "window.width": {
      immediate: true,
      async handler(newVal, oldVal) {

        let state = this.bltransactions;

        //HIDE COLUMNS BELOW WIDTH
        if (newVal < 1500) {
          state.fields[10].class = "d-none"
          state.fields[11].class = "d-none"
        } else {
          state.fields[10].class = "text-center"
          state.fields[11].class = "text-center"
        }
        // if (newVal < 1800) {
        //   state.fields[7].class = "d-none"
        //   // state.fields[6].class = "d-none"
        //   // state.fields[8].class = "d-none"
        //   // state.fields[9].class = "d-none"
        //   state.fields[10].class = "d-none"
        //   state.fields[11].class = "d-none"
        // } else {
        //   state.fields[6].class = "text-center"
        //   // state.fields[8].class = "text-center"
        //   // state.fields[9].class = "text-center"
        //   state.fields[10].class = "text-center"
        //   state.fields[11].class = "text-center"
        // }
      },
    },
  },
  data() {
    return {
      busy: false,
      id: null,
      query: null,
      due: 0,
      costtotal: 0,
      ref: null,
      reflist: [],
      datetransaction: {
        startDate: this.$moment().format("YYYY-MM-DD"),
        endDate: this.$moment().format("YYYY-MM-DD"),
      },
      credit: null,
      type: [],
      type_options: [
        { id: "A", label: "A | Dummy Payments/Receipts" },
        // { id: "G", label: "G | " },
        { id: "PA", label: "PA | Adjustments" },
        // { id: "PO", label: "PO | " },
        { id: "PP", label: "PP | Bank Payments/Receipts" },
        { id: "T,TI", label: "T | Invoice/Credit" },
        // { id: "TI", label: "TI | Invoice/Credit" },
      ],
      fuzzyall: true,
      blac: [],
      slac: [],
      slaclike: null,
      slaclike_visible: null,
      reflike: null,
      reflike_visible: null,
      passenger: null,
      bspref: null,
      ticketno: [],
      confermatransactionid: [],
      yourref: null,
      refcredit: null,
      eventcode: [],
      datetravel: null,
      ispaid: null,
      isarchive: "0",
      isactive: "1",
      active_options: [
        {
          id: "1",
          label: "Yes",
        },
        {
          id: "0",
          label: "No",
        },
      ],
      amnt: {
        min: null,
        max: null,
      },
      comm: {
        min: null,
        max: null,
      },
      iscommnotzero: null,
      item: {},
      blquery_options: [
        {
          id: "*",
          label: "All",
        },
        {
          id: "outstanding",
          label: "Outstanding Balances",
        },
      ],
      transtype_options: [],

      bltransactions: {
        title: "Costs ( Bought Ledger )",
        icon: "fa fa-pie-chart",
        selectall: false,
        debounce: 500,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        toolbarlibrary: [
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-repeat text-primary",
            position: "toolbar",
            action: "amend",
            label: "Amend",
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-link text-orange",
            position: "toolbar",
            action: "match",
            label: "Match",
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-adjust text-primary",
            position: "toolbar",
            action: "adjustment",
            label: "Adjustment",
            component: {
              name: "",
            },
          },
        ],
        tools: "go,filter,download,clipboard,add,edit,deleteconfirm,amend,adjustment,receipt,match,invoice,credit",
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-right w-50px text-primary",
          },
          {
            key: "dateref",
            label: "Date",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .format("DD/MM/YYYY HH:mm");
              }
              return result;
            },
          },
          {
            key: "counter",
            label: "ID",
            sortable: true,
            class: "text-left d-none",
          },
          {
            key: "invoiceno",
            label: "Ref",
            sortable: true,
            class: "text-centre w-80px",
          },
          {
            key: "refcredit",
            label: "Cr Ref",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          {
            key: "blac",
            label: "BL A/C",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          // {
          //   key: "slac",
          //   label: "SL A/C",
          //   sortable: true,
          //   class: "d-none d-sm-table-cell",
          // },
          {
            key: "passenger",
            label: "Description",
            sortable: true,
            class: "d-none d-sm-table-cell",
            formatter: (value, key, item) => {
              let result = value;
              if (result) {
                if (result.length > 30) {
                  result = result.slice(0, 27) + "...";
                }
              }
              return result;
            },
          },

          {
            key: "eventcode",
            label: "Event",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          {
            key: "ticketno",
            label: "TicketNo",
            sortable: true,
            class: "d-none d-sm-table-cell",
            formatter: (value, key, item) => {
              let result = value;
              if (result) {
                if (result.length > 10) {
                  result = result.slice(0, 12) + "...";
                }
              }
              return result;
            },
          },
          {
            key: "datetravel",
            label: "DateTravel",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment.unix(value / 1000).format("DD/MM/YYYY");
              }
              return result;
            },
          },
          {
            key: "route",
            label: "Route / Details",
            sortable: true,
            class: "d-none d-sm-table-cell",
            formatter: (value, key, item) => {
              let result = value;
              if (result) {
                if (result.length > 30) {
                  result = result.slice(0, 27) + "...";
                }
              }
              return result;
            },
          },
          // {
          //   key: "costexvat",
          //   label: "Ex VAT",
          //   sortable: true,
          //   class: "text-right",
          //   formatter: (value, key, item) => {
          //     if (value) {
          //       return parseFloat(value).toFixed(2);
          //     } else {
          //       return value;
          //     }
          //   },
          //   totalled: true,
          //   total: 0,
          // },
          // {
          //   key: "comm",
          //   label: "Comm",
          //   sortable: true,
          //   class: "text-right",
          //   formatter: (value, key, item) => {
          //     if (value) {
          //       return parseFloat(value).toFixed(2);
          //     } else {
          //       return value;
          //     }
          //   },
          //   totalled: true,
          //   total: 0,
          // },
          // {
          //   key: "costvat",
          //   label: "VAT",
          //   sortable: true,
          //   class: "text-right",
          //   formatter: (value, key, item) => {
          //     if (value) {
          //       return parseFloat(value).toFixed(2);
          //     } else {
          //       return value;
          //     }
          //   },
          //   totalled: true,
          //   total: 0,
          // },
          {
            key: "costtotal",
            label: "Amount",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
            totalled: true,
            total: 0,
          },
          {
            key: "due",
            label: "Due",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
            totalled: true,
            total: 0,
          },
          {
            key: "bltype",
            label: "ST",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          {
            key: "lines",
            label: "Lines",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          {
            key: "age",
            label: "Age",
            sortable: true,
            class: "text-left d-none",
          },
          {
            key: "type",
            label: "Type",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "notes",
            label: "Notes",
            sortable: true,
            class: "text-left d-none",
          },

          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px w-sm-100pct",
          },
        ],
        badges: [
          {
            key: "type",
            type: "badge",
            Refund: "white",
            Credit: "danger",
            Invoice: "success"
          },
          {
            key: "bltype",
            type: "pill",
            class: "secondary",
          },
        ],
        items: [],
        selected: [],
        downloaded: [],
        denied: [],
      },
    };
  },
  async mounted() {
    this.accessdenied();
  },

  methods: {
    accessdenied() {
      this.bltransactions.denied = [];
      if (!this.user.permissions.includes("boughtledger.delete")) {
        this.bltransactions.denied.push("deleteconfirm");
      }
      if (!this.user.permissions.includes("boughtledger.save")) {
        this.bltransactions.denied.push("add");
        this.bltransactions.denied.push("edit");
        this.bltransactions.denied.push("save");
           this.bltransactions.denied.push("receipt");
      }
      if (!this.user.permissions.includes("systems.development")) {
        this.bltransactions.denied.push("adjustment");     
      }
    },

    async bltransactions_clear() {
      let state = this.bltransactions;
      state.items = []
      state.offset = 0
      state.page = 1
    },

    blinvoice_add() {
      this.item = {
        id: "",
        type: "IG",
        date_at: this.$moment().startOf('month').toDate(),
        description: "",
        referenceno: "IG*new*",
        yourref: "",
        refcredit: "",
        items: [
          {
            id: "",
            bltype: null,
            nlcode: null,
            type: "IG",
            referenceno: "IG*new*",
            qty: "1",
            vatrate: "Z",
            price: (0).toFixed(2),
            vat: (0).toFixed(2),
            total: (0).toFixed(2)
          }
        ]
      }
    },

    blinvoice_adjust() {
      this.item = {
        id: "",
        type: "AG",
        date_at: this.$moment().startOf('month').toDate(),
        items: [
          {
            id: "",
            adjustment_type: "A",
            referenceno: "IG*new*",
            qty: "1",
            vatrate: "Z",
            price: (0).toFixed(2),
            vat: (0).toFixed(2),
            total: (0).toFixed(2)
          }
        ]
      }
    },
    async bltransactions_load(offset, limit, page) {

      let state = this.bltransactions;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      if (limit != 0) { state.busy = true; }

      let variables = {
        offset: state.offset,
        limit: state.limit,
        daterefs: [
          this.datetransaction.startDate
            ? this.$moment(this.datetransaction.startDate).format("YYYY-MM-DD")
            : null,
          this.datetransaction.endDate
            ? this.$moment(this.datetransaction.endDate).format("YYYY-MM-DD")
            : null,
        ],
        ref: this.ref,
        reflist: this.reflist.length > 0 ? this.reflist.join(",") : null,
        blac: this.blac.length > 0 ? this.blac.join(",") : null,
        slac: this.slac.length > 0 ? this.slac.join(",") : null,
        slaclike: this.slaclike,
        passenger: this.passenger,
        bspref: this.bspref,
        ticketno: this.ticketno.length > 0 ? this.ticketno.join(",") : null,
        confermatransactionid: this.confermatransactionid.length > 0 ? this.confermatransactionid.join(",") : null,
        yourref: this.yourref,
        refcredit: this.refcredit,
        eventcode: this.eventcode.length > 0 ? this.eventcode.join(",") : null,
        datetravel: this.datetravel,
        iscredit: this.credit,
        isarchive: this.isarchive,
        isactive: this.isactive,
        ispaid: this.ispaid,
        query: this.query,
        transtype: this.type.length > 0 ? this.type.join(",") : null,
        amnt: this.amnt.min ? [this.amnt.min, this.amnt.max] : null,
        comm: this.comm.min ? [this.comm.min, this.comm.max] : null,
        iscommnotzero: this.iscommnotzero ? "1" : "0",
        dateformat: "DD/MM/YYYY HH:MM",
        mssql: true,
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query BLTransactions(
              $mssql: Boolean
              $offset: Int
              $limit: Int
              $ref: String
              $reflist: String
              $daterefs: [String]
              $blac: String
              $slac: String
              $slaclike: String
              $passenger: String
              $bspref: String
              $ticketno: String
              $confermatransactionid: String
              $yourref: String
               $refcredit: String
              $eventcode: String
              $datetravel: String
              $iscredit: Boolean
              $ispaid: Boolean
              $query: String
              $transtype: String
                 $amnt:[String], 
              $comm:[String], 
              $iscommnotzero: String
              $isarchive: String
               $isactive: String
              $dateformat: String
            ) {
              BLTransactions(
                mssql: $mssql
                offset: $offset
                limit: $limit
                daterefs: $daterefs
                ref: $ref
                reflist: $reflist
                blac: $blac
                slac: $slac
                slaclike: $slaclike
                passenger: $passenger
                bspref: $bspref
                ticketno: $ticketno
                confermatransactionid: $confermatransactionid
                yourref: $yourref
                   refcredit: $refcredit
                eventcode: $eventcode
                datetravel: $datetravel
                iscredit: $iscredit
                ispaid: $ispaid
                query: $query
                transtype: $transtype
                  amnt:$amnt, 
                comm:$comm, 
                iscommnotzero:$iscommnotzero, 
                isarchive: $isarchive
                 isactive: $isactive
                dateformat: $dateformat
              ) {
                id
                entry
                type
                line
                ref
                yourref
                refcredit
                dateref
                to
                blac
                slac
                eventcode
                bspref
                refcredit
                datetravel
                datepaid
                credit
                # comm
                costexvat
                costvat
                costtotal
                due
                taxes
                passenger
                ticketno
                route
                confermatransactionid
                invoiceno: ref
                remittanceno
                bltype
                lines
                age
                 active
                updated_by
                updated_at
                notes
                counter
                rows
              }
            }
          `,
          variables,
        });

        state.downloaded = []
        if (limit == 0) {
          state.downloaded = response.data.BLTransactions
        } else {
          state.items = response.data.BLTransactions;
        }

      } catch (error) {
        console.log(error);
      }

      state.busy = false;
    },
    async bltransactions_click(a, ss) {
      console.log("bltransactions_click", a, ss);

      let state = this.bltransactions;

      switch (a) {

        case "download_view":
          state.downloaded = []
          state.downloaded = state.items
          break;

        case "download_all":
          state.downloaded = []
          await this.bltransactions_load(0, 0);
          break;

        case "filter":
          this.showfilter = !this.showfilter;
          break;

        case "discard":
          this.component = null;
          break;

        case "go":
          this.component = null;
          await this.bltransactions_load(0);
          break;

        case "add":
          this.blinvoice_add();
          this.component = "BLInvoiceEdit";
          break;

        case "edit":
          this.component = "BLItemEdit2";
          break;

        case "amend":
          this.component = "BLAmend";
          break;

        case "payment":
          await this.payment();
          this.component = "BLPayment";
          break;

            case "receipt":
          await this.payment();
          this.component = "BLPayment";
          break;

        case "adjustment":
          this.blinvoice_adjust();
          this.component = "BLAdjustments";
          break;

        case "match":
          this.component = "BLMatch";
          break;

        case "delete":
          this.bltransactions_deleteit(ss);
          break;

        case "invoice":
          if (ss.length > 0) {
            if (ss[0].invoiceno) {
              this.component = "TicketsInvoice";
            } else {
              this.component = null;
            }
          }
          break;

        case "credit":
          this.component = "BLItemCredit";
          break;
      }
    },
    async bltransactions_select(ss, tools) {

      let state = this.bltransactions;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "download", "clipboard", 'match'];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 0
        enabled = ["add", "adjustment", "receipt"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 0 ? false : true;
          }
        });
        // == 1
        enabled = ["invoice", "credit"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["edit", "amend", "deleteconfirm", "credit"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },

    async bltransactions_deleteit(ss) {
      console.log("bltransactions_delete", ss);

      let state = this.bltransactions;
      state.busy = true

      let rows = [];
      ss.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      console.log(variables);
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation BL_delete($rows: [BLTransaction_input]) {
              BL_delete(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }
      state.busy = false

      await this.bltransactions_load(0);
    },

    async payment() {
      this.item = {
        id: "",
        date_at: this.$moment().startOf('month').toDate(),
        items: [
          {
            prefix: 'PP',
            description: 'BACS ', //+ this.$moment.unix(this.item.date_at * .001).utc(true).format('DD.MM.YY'),
            blac: null,
            eventcode: null,
            nlcode: "1200",
            amount: "0.00",
            // qty: "1",
            // vatrate: "Z",
            // price: (0).toFixed(2),
            // vat: (0).toFixed(2),
            // total: (0).toFixed(2)
          }
        ]
      }
    }

    // async bltransactions_creditit(ss) {

    //   let state = this.bltransactions;

    //   if (await this.$bvModal.msgBoxConfirm('This will be a full credit.', {
    //     title: 'Please confirm you want to credit these invoice(s)?',
    //     size: 'lg',
    //     buttonSize: 'sm',
    //     okVariant: 'success',
    //     okTitle: 'Yes',
    //     cancelTitle: 'No',
    //     footerClass: 'p-2',
    //     hideHeaderClose: false,
    //     centered: true
    //   })) {

    //     state.busy = true;

    //     let variables = { rows: this.cleanit(ss) };


    //     // let actions = this.credit
    //     // if (this.credithold) { actions.push('creditzhold') }

    //     // let variables = {
    //     //   rows,
    //     //   options: JSON.stringify({
    //     //     actions,
    //     //     date_at: this.date_at,
    //     //     reasontype: this.reasontype,
    //     //     reason: this.reason,
    //     //     reinvoice: {
    //     //       yourref: this.reasontype == 'reinvoice' ? this.yourref : null,
    //     //       slac: this.reasontype == 'reinvoice' ? this.slac : null,
    //     //       eventcode: this.reasontype == 'reinvoice' ? this.eventcode : null,
    //     //     }

    //     //   })
    //     // };
    //     // console.log("variables", variables);

    //     // try {
    //     //   const response = await this.$apollo.mutate({
    //     //     mutation: gql`
    //     //                   mutation BL_credit($rows: [SLTransaction_input], $options:String) {
    //     //                   BL_credit(rows: $rows, options: $options) {
    //     //                       id
    //     //                       invoiceno
    //     //                   }
    //     //               }
    //     //               `,
    //     //     variables,
    //     //   });
    //     //   this.message = "<span class='text-primary'>Posted it. " + response.data.BL_credit.map(o => o.invoiceno).join(", ") + " </span>";
    //     //   this.posted = true

    //     // } catch (error) {
    //     //   this.message = "<span class='text-danger'>" + error.message + "</span>";
    //     // }

    //   } else {

    //   }

    //   state.busy = false;
    //   await this.bltransactions_load(0);

    // },


  },
};
</script>

<style></style>